import { useSnackbar } from "notistack";
import { useFormField } from "../../../CustomHooks/ComposedForm.fs.js";
import { Compensation, SelectOptionData$1_Create_Z510A3DC0 } from "../../../shared/Domain.fs.js";
import { useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { createElement } from "react";
import { Row, Col } from "../../../Components/UtilComponents.fs.js";
import { ofArray, singleton, empty } from "../fable_modules/fable-library.3.7.17/List.js";
import { MarginTop, Gap, PaddingTop, PaddingBottom } from "../../../Styles/Utils.fs.js";
import { CompensationOptionsRestricted } from "../../../DesignSystems/DossierUtils.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.1.2.6/./Mui.fs.js";
import Button from "@material-ui/core/Button";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { singleton as singleton_1 } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { compensations } from "../AppRoutes.fs.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.68.0/./Interop.fs.js";
import { useFeliz_React__React_useDeferred_Static_2344FC52 } from "../fable_modules/Feliz.UseDeferred.1.5.0/UseDeferred.fs.js";
import { Page } from "../components/Page.fs.js";
import { DisplayDeferred } from "../../../DesignSystems/DisplayDeferred.fs.js";
import { defaultArg } from "../fable_modules/fable-library.3.7.17/Option.js";

export function CompensationEditForm(compensationEditFormInputProps) {
    const api = compensationEditFormInputProps.api;
    const initialEpc = compensationEditFormInputProps.initialEpc;
    const initialAia = compensationEditFormInputProps.initialAia;
    const snackbar = useSnackbar();
    const compensationAia = useFormField(initialAia, SelectOptionData$1_Create_Z510A3DC0);
    const compensationEpc = useFormField(initialEpc, SelectOptionData$1_Create_Z510A3DC0);
    const patternInput = useFeliz_React__React_useState_Static_1505(false);
    const setDisableButtons = patternInput[1];
    return createElement(Col, {
        classes: empty(),
        children: ofArray([createElement(Row, {
            classes: singleton(PaddingBottom.M),
            children: singleton("In de prijslijst bovenaan is er geen partnervergoeding begrepen."),
        }), createElement(Col, {
            classes: singleton(PaddingBottom.M),
            children: ofArray([createElement("h2", {
                children: ["Vergoeding AIA"],
            }), createElement(CompensationOptionsRestricted, compensationAia)]),
        }), createElement(Col, {
            classes: singleton(PaddingBottom.M),
            children: ofArray([createElement("h2", {
                children: ["Vergoeding EPC"],
            }), createElement(CompensationOptionsRestricted, compensationEpc)]),
        }), createElement(Row, {
            classes: ofArray([PaddingTop.S, PaddingBottom.M]),
            children: singleton("Deze vergoeding is exclusief 21% BTW en wordt per kwartaal afgerekend."),
        }), createElement(Row, {
            classes: ofArray([Gap.M, MarginTop.L]),
            children: singleton(MuiHelpers_createElement(Button, [["disabled", patternInput[0]], ["color", "primary"], ["variant", "contained"], ["onClick", (_arg_3) => {
                setDisableButtons(true);
                startImmediate(singleton_1.Delay(() => singleton_1.TryFinally(singleton_1.Delay(() => singleton_1.TryWith(singleton_1.Delay(() => {
                    let c_2;
                    let aiaResult;
                    const matchValue = compensationAia.FieldValue;
                    aiaResult = ((matchValue == null) ? (void 0) : matchValue);
                    let epcResult;
                    const matchValue_1 = compensationEpc.FieldValue;
                    epcResult = ((matchValue_1 == null) ? (void 0) : matchValue_1);
                    let hasError = false;
                    return singleton_1.Combine((aiaResult == null) ? ((singleton_1.Zero())) : ((c_2 = aiaResult, singleton_1.Bind(api.UpdateCompensationAmount(c_2), (_arg) => {
                        const r = _arg;
                        if (r.tag === 0) {
                            return singleton_1.Zero();
                        }
                        else {
                            const err = r.fields[0];
                            hasError = true;
                            console.log(err);
                            ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Kon AIA-vergoeding niet bewaren. [${err}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                            return singleton_1.Zero();
                        }
                    }))), singleton_1.Delay(() => {
                        let c_3;
                        return singleton_1.Combine((epcResult == null) ? ((singleton_1.Zero())) : ((c_3 = epcResult, singleton_1.Bind(api.UpdateCompensationAmountEpc(c_3), (_arg_1) => {
                            const r_1 = _arg_1;
                            if (r_1.tag === 0) {
                                return singleton_1.Zero();
                            }
                            else {
                                const err_1 = r_1.fields[0];
                                hasError = true;
                                console.log(err_1);
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Kon EPC-vergoeding niet bewaren. [${err_1}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                return singleton_1.Zero();
                            }
                        }))), singleton_1.Delay(() => {
                            setDisableButtons(false);
                            if (!hasError) {
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Vergoedingen bewaard", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                RouterModule_nav(ofArray(Page$2__toUrl_2B594(compensations)), 1, 1);
                                return singleton_1.Zero();
                            }
                            else {
                                return singleton_1.Zero();
                            }
                        }));
                    }));
                }), (_arg_2) => {
                    const e = _arg_2;
                    setDisableButtons(false);
                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren.  [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                    console.log(e);
                    return singleton_1.Zero();
                })), () => {
                })));
            }], ["children", Interop_reactApi.Children.toArray(["Bewaren"])]])),
        })]),
    });
}

export function CompensationsEdit(compensationsEditInputProps) {
    const api = compensationsEditInputProps.api;
    const currentPage = compensationsEditInputProps.currentPage;
    const aiaData = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetCompensationAmount(), []);
    const epcData = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetCompensationAmountEpc(), []);
    return createElement(Page, {
        currentPage: currentPage,
        title: "Vergoedingen",
        actions: [],
        children: [createElement(DisplayDeferred, {
            data: aiaData,
            view: (aia) => createElement(DisplayDeferred, {
                data: epcData,
                view: (epc) => {
                    const aia_1 = defaultArg(aia, new Compensation(2));
                    const epc_1 = defaultArg(epc, new Compensation(2));
                    return createElement(CompensationEditForm, {
                        initialAia: aia_1,
                        initialEpc: epc_1,
                        api: api,
                    });
                },
            }),
        })],
    });
}

